<i class="ui-search__leading-icon fa fa-search"
    [ngClass]="{
        'loading': loading,
        'has-value': hasValue
    }"
></i>
<input
        type="text"
        class="ui-search__input"
        [ngClass]="{ 'loading': loading, 'has-value': _search.value.trim().length > 0 }"
        [placeholder]="placeholder"
        [attr.disabled]="loading ? 'true' : null"
        [formControl]="_search"
        (focusin)="_focused = true"
        (focusout)="_focused = false"
>
<i class="ui-search__trailling-icon flaticon2-cross"
   [ngClass]="{
        'has-value': hasValue
    }"
   (click)="_search.setValue('')"
></i>
